import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();
  return (
    <div className="flex text-[12px]">
      <div className="w-[110px]">{t('Signal.wallet')}</div>
      <div className="w-[77px]">{t('Signal.mc')}</div>
      <div className="w-[77px]">{t('Signal.bought')}</div>
      <div className="w-[77px]">{t('Signal.totalProfit')}</div>
    </div>
  );
};
